export const StatusTypes = {
  enCours: "enCours",
  terminee: "terminee",
  annulee: "annulee",
  echouee: "echouee",
  remboursee: "remboursee",
  enRetard: "enRetard",
  enAttente: "enAttente",
};

export const formatStatusText = (status) => {
  switch (status) {
    case StatusTypes.enCours:
      return "En Cours";
    case StatusTypes.terminee:
      return "Terminée";
    case StatusTypes.annulee:
      return "Annulée";
    case StatusTypes.echouee:
      return "Échouée";
    case StatusTypes.remboursee:
      return "Remboursée";
    case StatusTypes.enRetard:
      return "En Retard";
    case StatusTypes.enAttente:
      return "En Attente";
    default:
      return "En Cours";
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case StatusTypes.enCours:
      return "info";
    case StatusTypes.terminee:
      return "success";
    case StatusTypes.annulee:
      return "warning";
    case StatusTypes.echouee:
      return "error";
    case StatusTypes.remboursee:
      return "secondary";
    case StatusTypes.enRetard:
      return "error";
    case StatusTypes.enAttente:
      return "warning";
    default:
      return "info";
  }
};

export const StatusList = [
  { _id: StatusTypes.enCours, label: formatStatusText(StatusTypes.enCours), labelKey: "status.enCours" },
  { _id: StatusTypes.terminee, label: formatStatusText(StatusTypes.terminee), labelKey: "status.terminee" },
  { _id: StatusTypes.annulee, label: formatStatusText(StatusTypes.annulee), labelKey: "status.annulee" },
  { _id: StatusTypes.echouee, label: formatStatusText(StatusTypes.echouee), labelKey: "status.echouee" },
  { _id: StatusTypes.remboursee, label: formatStatusText(StatusTypes.remboursee), labelKey: "status.remboursee" },
  { _id: StatusTypes.enRetard, label: formatStatusText(StatusTypes.enRetard), labelKey: "status.enRetard" },
  { _id: StatusTypes.enAttente, label: formatStatusText(StatusTypes.enAttente), labelKey: "status.enAttente" },
];
